<template>
<md-layout md-column class="ql-cue-list" >
    <p v-if="globalCuesLength == 0" class="md-body-2">You haven't created any cues on this page. Double click to add cues and right click to add notes.</p>
    <project-cues-cue v-for="(cue, index) in cues"
        :key="cue.id"
        :cue="cue"
        :class="cuePlacementclass(cue)"
        :open="isOpen(cue)"
        :locked="locked"
        :cuesListWidth="cuesListWidth"
        :svgContentWidth="svgContentWidth"
        :svgTrueHeight="svgTrueHeight"
        :cueIndex="index"
        :currentPage="currentPage"
        :openCues="openCues"
        @openCue="openCue(cue)"
        @closeCue="closeCue(cue)"
        @destroy="destroy"
        @updatedCue="updatedCue" />
</md-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import ProjectCuesCue from '@/components/project/cues/cue';

const ProjectCueList = {
    name: 'projectCueList',
    props: ['cues', 'openCues', 'locked', 'globalCuesLength', 'cuesListWidth', 'svgContentWidth', 'svgTrueHeight', 'currentPage'],
    data: function() {
        return {};
    },
    computed: {
        ...mapGetters([
            'cuePlacement',
            'layerByCue',
            'getDefaultCuePlacement'
        ])
    },
    methods: {
        isOpen(cue) {
            return this.openCues.some(c => c.id === cue.id);
        },
        cuePlacementclass(cue) {
            const defaultCuePlacement = this.getDefaultCuePlacement(cue.layer);
            if (defaultCuePlacement === 'left' || defaultCuePlacement === 'right') {
                return `${defaultCuePlacement}-edge`;
            }
            return defaultCuePlacement;
        },
        openCue(cue) {
            this.$emit('openCue', cue);
        },
        closeCue(cue) {
            this.$emit('closeCue', cue);
        },
        destroy(cue) {
            this.$emit('destroy', cue);
        },
        updatedCue(cue) {
            this.$emit('updatedCue', cue);
        }
    },
    components: {
        'project-cues-cue': ProjectCuesCue
    }
};

export default ProjectCueList;
</script>

<style lang="scss">
.ql-cue-list {
    position: relative;
    padding-top: 6px;
    padding-left: 15px;
    max-width: 500px;
    flex: 0 0 30%;
    &.left-edge {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        max-width: 100%;
    }
    &.right-edge {
        position: absolute;
        left: auto;
        top: 0;
        width: 100%;
        height: 100%;
        max-width: 100%;
    }

    &:not(.right-edge), &:not(.left-edge) {
        position: absolute;
        left: auto;
        top: 0;
        width: 100%;
        height: 100%;
        max-width: 100%;
        padding: 0;
    }
}
</style>


// WEBPACK FOOTER //
// cue-list.vue?509dd37c